// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes loader {\n  to {\n    background-position: 100%, 0;\n  }\n}\n\n.skeleton_block {\n  display: inline-block;\n  background: linear-gradient(to right, #f3f3f3 2%, #e9e9e9 16%, #f3f3f3 38%);\n  border-radius: 6px;\n  width: 100%;\n  height: 1rem;\n  animation: loader 1s infinite ease-in-out;\n  background-position: 0% 0;\n}\n", ""]);
// Exports
module.exports = exports;
